const loadRecaptchaScript = (siteKey: string) => {
  return new Promise<void>((resolve, reject) => {
    // Check if site key is available
    if (!siteKey) {
      console.error("reCAPTCHA site key is not available");
      reject(new Error("reCAPTCHA site key is not available"));
      return;
    }

    const existingScript = document.getElementById("recaptcha-script");
    if (existingScript) {
      console.log("reCAPTCHA script already loaded");
      resolve();
      return;
    }

    console.log(
      "Loading reCAPTCHA script with site key:",
      siteKey?.substring(0, 10) + "...",
    );

    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    script.id = "recaptcha-script";
    script.async = true;
    script.defer = true;

    script.onload = () => {
      console.log("reCAPTCHA script loaded successfully");
      resolve();
    };

    script.onerror = (error) => {
      console.error("Failed to load reCAPTCHA script:", error);
      console.error("Script URL was:", script.src);
      reject(new Error("Failed to load reCAPTCHA script"));
    };

    document.body.appendChild(script);
  });
};

const unloadRecaptchaScript = () => {
  console.log("Unloading reCAPTCHA script");
  const script = document.getElementById("recaptcha-script");
  const elements = document.querySelectorAll(`.grecaptcha-badge`);
  if (script) {
    document.body.removeChild(script);
    elements.forEach((element) => element.remove());
  }
};

export { loadRecaptchaScript, unloadRecaptchaScript };
